import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import Tables from "../../Components/AdminStaff/Tables";
import AddStaff from "../../Components/AdminStaff/AddStaff";
import { toast } from "react-toastify";
import EditStaff from "../../Components/AdminStaff/EditStaff";
import moment from "moment";
import { Form, Formik } from "formik";
import SideModal from "../../Components/SideModal";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DeleteStaff from "../../Components/AdminStaff/DeleteStaff";
import { AddBtn } from "../../Components/Styles/InputStyles";
import LinkUnlink from "../../Components/AdminStaff/LinkUnlink";
import DeactivateStaff from "../../Components/AdminStaff/DeactivateStaff";

const AdminStaff = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState();
  const [isAddStaff, setIsAddStaff] = useState(false);
  const [key, setKey] = useState("");
  const [isEditStaff, setIsEditStaff] = useState(false);
  const [isDeactivateStaff, setIsDeactivateStaff] = useState(false);
  const [attendanceFlag, setAttendanceFlag] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isDeleteStaff, setIsDeleteStaff] = useState(false);
  const [linkStaff, setLinkStaff] = useState(false);

  const initialValues = {
    startDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const getFilterType = (type) => {
    switch (type) {
      case 1:
        return "MOBILE";
      case 2:
        return "NAME";
      default:
        return "";
    }
  };

  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    let url = `${Config.apiUrl}/staff/list?${query}`;

    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.list);
      setAttendanceFlag(res?.attendanceFlag);
    }
  };
  const getError = (res) => {};

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const handleFilterChange = (values) => {
    const type = getFilterType(values.filterType);
    setFilterType(type);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: type,
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate({ searchQuery, filterType });
    }, 50);
    return () => {
      clearTimeout(handler);
    };
  }, []);

  const submitHandler = (values) => {
    getListMutate({ searchQuery, filterType });
  };
  //------- Add Staff -------
  const addStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/add`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAddStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addStaffLoading, mutate: addStaffMutate } = useMutation(
    addStaffFunction,
    {
      onSuccess: onAddStaffSuccess,
      onError: onAddStaffError,
    },
  );

  //------- Edit Staff -------
  const editStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/edit`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsEditStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onEditStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editStaffLoading, mutate: editStaffMutate } = useMutation(
    editStaffFunction,
    {
      onSuccess: onEditStaffSuccess,
      onError: onEditStaffError,
    },
  );

  //------- Delete Staff -------
  const deleteStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteStaffError = (data) => {
    setIsDeleteStaff(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteStaffLoading, mutate: deleteStaffMutate } =
    useMutation(deleteStaffFunction, {
      onSuccess: deleteStaffSuccess,
      onError: deleteStaffError,
    });

  const handleStaffClose = () => {
    setIsDeleteStaff(false);
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };
  // -----Link-Unlink Staff-----
  const linkInventoryStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/toggle`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const { mutate: linkInventoryStaffMutate } = useMutation(
    linkInventoryStaffFunction,
  );

  //------- Activate / Inactivate Staff -------

  const deactivateStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/status`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const deactivateStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Status Updated Successfully");

      setIsDeactivateStaff(false);

      getListMutate({
        searchQuery,
        filterType,
      });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deactivateStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateStaffLoading, mutate: deactivateStaffMutate } =
    useMutation(deactivateStaffFunction, {
      onSuccess: deactivateStaffSuccess,
      onError: deactivateStaffError,
    });

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Staffs
            <Underline />
          </BoxTitle>
          <Filters
            submitHandler={submitHandler}
            initialValues={initialValues}
            setIsAddStaff={setIsAddStaff}
            setKey={setKey}
          />
        </BoxHead>

        <SideModal isOpen={isAddStaff} onClose={() => setIsAddStaff(false)}>
          <AddStaff
            key={key} //Key is needed to reset the form
            setIsAddStaff={setIsAddStaff}
            isAddStaff={isAddStaff}
            addStaffLoading={addStaffLoading}
            addStaffMutate={addStaffMutate}
            property={propertyList}
          />
        </SideModal>

        <SideModal isOpen={isEditStaff} onClose={() => setIsEditStaff(false)}>
          <EditStaff
            isEditStaff={isEditStaff}
            setIsEditStaff={setIsEditStaff}
            editStaffLoading={editStaffLoading}
            editStaffMutate={editStaffMutate}
            selectedData={selectedData}
            isDeactivateStaff={isDeactivateStaff}
            setIsDeactivateStaff={setIsDeactivateStaff}
          />
        </SideModal>

        {isDeactivateStaff && (
          <DeactivateStaff
            selectedData={selectedData}
            setIsDeactivateStaff={setIsDeactivateStaff}
            deactivateStaffLoading={deactivateStaffLoading}
            deactivateStaffMutate={deactivateStaffMutate}
          />
        )}

        <SideModal isOpen={linkStaff} onClose={() => setLinkStaff(false)}>
          <LinkUnlink
            selectedData={selectedData}
            linkStaff={linkStaff}
            setLinkStaff={setLinkStaff}
            linkInventoryStaffMutate={linkInventoryStaffMutate} // pass your mutation
          />
        </SideModal>

        <FilterTableWrapper>
          <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center">
              <Text>
                Total staff:{" "}
                <span className="font-semibold">{apiData?.length || 0}</span>
              </Text>
            </div>
            <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
            </div>
          </FilterWrapper>
          {isDeleteStaff && (
            <DeleteStaff
              setIsDeleteStaff={setIsDeleteStaff}
              isDeleteStaff={isDeleteStaff}
              deleteStaffLoading={deleteStaffLoading}
              deleteStaffMutate={deleteStaffMutate}
              selectedData={selectedData}
              handleClose={handleStaffClose}
            />
          )}
          {!isLoading && (
            <TableWrapper>
              <Tables
                apiData={apiData}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                setIsEditStaff={setIsEditStaff}
                attendanceFlag={attendanceFlag}
                setIsDeleteStaff={setIsDeleteStaff}
                setLinkStaff={setLinkStaff}
                setIsDeactivateStaff={setIsDeactivateStaff}
              />
              {(!apiData || apiData.length === 0) && <NotFoundModel />}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {/* </>
        )} */}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, setIsAddStaff, setKey }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddStaff(true);
            }}
          >
            {"Add Staff"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const Text = tw.p`text-gray-500 text-sm font-normal`;

export default AdminStaff;
